import React from "react";

// Custom three-connection mark for Bright EOR.
// Three nodes at 120° angles on a subtle ring, connected by dashed arcs.
// UK node (navy), India node (aqua), Bright EOR node (aqua) — connected in
// a triangular circuit to visualise the managed handoff between all three.
export const LogoMark = ({ size = 40, variant = "onLight" }) => {
  const ringStroke = variant === "onDark" ? "rgba(255,255,255,0.18)" : "rgba(11,29,52,0.12)";
  const dash = variant === "onDark" ? "rgba(207,246,244,0.55)" : "rgba(0,194,199,0.75)";
  const navyFill = variant === "onDark" ? "#FFFFFF" : "#0B1D34";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* orbit ring */}
      <circle cx="32" cy="32" r="22" stroke={ringStroke} strokeWidth="1.5" />
      {/* dashed connective arcs */}
      <path
        d="M32 10 A22 22 0 0 1 51.05 43"
        stroke={dash}
        strokeWidth="1.5"
        strokeDasharray="3 4"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M51.05 43 A22 22 0 0 1 12.95 43"
        stroke={dash}
        strokeWidth="1.5"
        strokeDasharray="3 4"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M12.95 43 A22 22 0 0 1 32 10"
        stroke={dash}
        strokeWidth="1.5"
        strokeDasharray="3 4"
        strokeLinecap="round"
        fill="none"
      />
      {/* three nodes */}
      <circle cx="32" cy="10" r="6" fill="#00C2C7" />
      <circle cx="51.05" cy="43" r="6" fill="#00C2C7" />
      <circle cx="12.95" cy="43" r="6" fill={navyFill} />
    </svg>
  );
};

export const Logo = ({ variant = "onLight", className = "", withWordmark = true }) => {
  const textColor = variant === "onDark" ? "text-white" : "text-navy";
  const accentColor = "text-aqua";
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <LogoMark size={36} variant={variant} />
      {withWordmark && (
        <span className={`font-display text-[19px] font-semibold tracking-tight ${textColor} leading-none`}>
          Bright <span className={accentColor}>EOR</span>
        </span>
      )}
    </div>
  );
};

export default Logo;
